// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__5gCCt","logo":"styles_logo__Pawl6","headerTxt":"styles_headerTxt__momke","contentTxt":"styles_contentTxt__XyReX"};